module.exports = __webpack_public_path__ + "assets/img/pin.4988e6d0.png";